// eslint-disable-next-line no-shadow
export enum DataCollectorTarget {
  ssv = 'ssv',
  json = 'json',
  currentUser = 'currentUser'
};
